export default __webpack_public_path__ + "static/media/product-3.70fb0625.jpg";